<script setup lang="ts">
import noDataImage from '@spectee/assets/images/img_notFound.png';

defineExpose({
  name: 'NoData',
});

interface Props {
  text: string;
  supplement?: string;
  imgUrl?: string | undefined;
}

const props = withDefaults(defineProps<Props>(), {
  text: 'まだユーザーを招待していません。',
  imgUrl: noDataImage,
});
</script>

<template>
  <div class="NoData">
    <img class="NoData__img" :src="imgUrl" alt="" />
    <p class="NoData__text">{{ text }}</p>
    <p v-if="supplement" class="NoData__supplement">
      {{ supplement }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.NoData {
  padding: $service-unit * 10 0;
  text-align: center;

  &__img {
    width: $service-unit * 60;
    height: $service-unit * 60;
  }

  &__text {
    margin-top: $service-unit * 4;
    font-size: $service-unit * 5;
    font-weight: bold;
    line-height: $service-line-height-mp;
  }

  &__supplement {
    margin-top: $service-unit * 4;
    font-size: $service-unit * 5;
    line-height: $service-line-height-mf;
    font-weight: $service-font-weight-n;
    font-style: $service-font-style-italic;
  }

  @media (max-width: 767px) {
    &__img {
      width: $service-unit * 25;
      height: $service-unit * 25;
    }

    &__text {
      font-size: $service-unit * 3;
    }

    &__supplement {
      font-size: $service-unit * 3;
    }
  }
}
</style>
